export default __webpack_public_path__ + "static/media/mobile.7b55ffc1.png";